import React, { useContext, useEffect, useState } from "react";
import { PanelContainer } from "../Cpanel/Components/PanelContainer";
import DataTableTemplate from "../Cpanel/Components/DataTableTemplate";
import {
  fetchData,
  getFilterButton,
  getFilterClearButton,
  getFilterDate,
  getFilterInputText,
  getFilterSelect,
  sendPostRequest,
} from "../Cpanel/Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ShopContext } from "../StateManagement/Contexts/ShopContext";
import { useForm } from "react-hook-form";
import { FilterMatchMode } from "primereact/api";

export const LocalPayList = () => {
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const { shopData } = useContext(ShopContext);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
    filters: {
      name: { value: "", matchMode: "contains" },
      Mob: { value: "", matchMode: "contains" },
      groupid: { value: null, matchMode: FilterMatchMode.IN },
      sex: { value: null, matchMode: FilterMatchMode.IN },
      org: { value: null, matchMode: FilterMatchMode.IN },
    },
  });
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    if (shopData?.Token) {
      sendPostRequest(
        "selllist",
        "token",
        shopData?.Token,
        bodyFormData,
        handleCreateCatResponse
      );
    }
  }, [shopData?.Token]);

  const handleCreateCatResponse = (data) => {
    console.log(data);
    setPageData(data?.data);
    setTotalRecords(data?.count);
  };

  const statusList = [
    { value: "1", label: "مرد" },
    { value: "2", label: "زن" },
  ];
  const cols = [
    {
      field: "buyername",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    // {
    //   field: "name",
    //   header: "نام و نام خانوادگی",
    //   body: (data, options) => data?.Name + " " + data?.Family,
    //   filter: true,
    //   filterPlaceholder: "نام را وارد کنید",
    //   showFilterMatchModes: false,
    //   showFilterOperator: false,
    //   filterApply: getFilterButton,
    //   filterElement: (options) =>
    //     getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
    //   filterClear: getFilterClearButton,
    // },
    {
      field: "buyername",
      header: "نام خریدار",
      body: (data, options) => data?.Name + " " + data?.Family,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
      filterClear: getFilterClearButton,
    },
    {
      field: "cashback",
      header: "تاریخ پرداخت",
      sortable: true,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterDate(
          options,
          "نام یا نام خانوادگی را وارد کنید...",
          watch,
          control
        ),
      filterClear: getFilterClearButton,
    },
    {
      field: "basketid",
      header: "شماره سبد",
      body: (data, options) => data?.Name + " " + data?.Family,
      filter: true,
      filterPlaceholder: "شماره سبد را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "شماره سبد را وارد کنید ..."),
      filterClear: getFilterClearButton,
    },
    // {
    //   field: "pic",
    //   header: "وضعیت",
    //   body: (data) => (data?.sex === 1 ? "مرد" : "زن"),
    //   filter: true,
    //   filterPlaceholder: "وضعیت را انتخاب کنید",
    //   showFilterMatchModes: false,
    //   filterApply: getFilterButton,
    //   filterElement: (options) =>
    //     getFilterSelect(options, statusList, "sex", "وضعیت را انتخاب کنید"),
    //   filterClear: getFilterClearButton,
    // },
    {
      field: "pic",
      header: "مبلغ پرداختی",
    },
    { field: "MaxsimumCashBack", header: "تعداد سکه پرداختی" },
    {
      field: "pic",
      header: "میزان کش بک ",
    },
    // {
    //   field: "CityName",
    //   header: "نمایش جزئیات",
    //   body: (data, options) => (
    //     <div className="my-1">
    //       <FontAwesomeIcon
    //         icon={"edit"}
    //         // onClick={() => handleOpeEditItem(data)}
    //         className="icon-sm prime-bg text-white p-1 text-center rounded"
    //         color="gray"
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <PanelContainer title={"فروش ها"}>
        <DataTableTemplate
          lazyState={lazyState}
          // header={header}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
        />
      </PanelContainer>
    </>
  );
};

      // <div className="d-flex w-75 flex-wrap justify-content-between align-items-center p-2">
      //   <div>
      //     <button className="btn btn-sm ">مجموع کش بک پرداختی</button>
      //     <button className="btn btn-sm btn-success">000 </button>
      //   </div>
      //   <div>
      //     <button className="btn btn-sm ">مجموع سکه های دریافتی</button>
      //     <button className="btn btn-sm btn-success">000 </button>
      //   </div>
      //   <div>
      //     <button className="btn btn-sm "> مجموع مبلغ دریافتی</button>
      //     <button className="btn btn-sm btn-success">000 </button>
      //   </div>
      //   {/* <p>مجموع سکه های دریافتی</p>
      //   <p>مجموع مبلغ دریافتی</p> */}
      // </div>